<script>
import moment from "moment";

import ConfirmationModalComponent from "../components/confirmation-modal.component";
export default {
   name: 'facilityBatchProcess',
   components: {
      ConfirmationModalComponent
   },
   data() {
      return {
         showSuccess: false,
         data: {
            batchProcessSwitch: false,
            time: null,
            timeZone: 'Asia/Manila',
            facility_id: window._app_facility.id
         },
         checkoutSettingData: {
            from: "00:00",
            to: "23:59",
            facility_id: window._app_facility.id
         },
         timeList: [],
         checkoutFromTimingList: [],
         checkoutToTimingList: [],
         isInvalidTimeSetting: false
      }
   },
   async mounted() {
      // get time
      await Promise.all([
         this.getSettings(),
         this.getCheckoutSettings()
      ]);
   },
   methods: {
      // populate time list and get the settings
      async getSettings() {
         const response = await this.$lionheart.get(
            "/v2/facility-settings/batch-auto-checkout-settings",
            { params: { facility_id: window._app_facility.id } }
         )
         const data = response.data.data;
         this.data.batchProcessSwitch = data.settings.enable ?? 'Off';
         this.data.time = data.settings.time ?? '10:00';
         this.data.timeZone = data.settings.timezone ?? 'Asia/Tokyo';
         this.timeList = data.times;
      },

      async getCheckoutSettings() {
         const response = await this.$lionheart.get(
            "/v2/facility-settings/checkout-timing-settings",
            { params: { facility_id: window._app_facility.id } }
         )
         const data = response.data.data;
         this.checkoutSettingData.from = data.from ?? '00:00';
         this.checkoutSettingData.to = data.to ?? '23:59';
         const checkoutFromTimingData = data.checkoutTimings;
         const checkoutToTimingData = [...checkoutFromTimingData]; //make a copy of an array
         checkoutFromTimingData.pop(); // need to do this to get the array
         this.checkoutFromTimingList = checkoutFromTimingData;
         checkoutToTimingData.shift();
         this.checkoutToTimingList = checkoutToTimingData;
      },

      async submitForm() {
         this.validateCheckoutTiming()
         if(this.isInvalidTimeSetting) {
            setTimeout(() => {
               this.isInvalidTimeSetting = false;
            },3000)
            return;
         };
         const response = await this.$lionheart.put(
            "/v2/facility-settings/update-auto-checkout-settings",
            this.data
         );
         if(response.status === 200) {
            await this.updateCheckoutTimingSettings()
         }

      },

      validateCheckoutTiming() {
         const fromTime = this.checkoutSettingData.from;
         const toTime = this.checkoutSettingData.to;
         if(fromTime == '00:00' && this.checkoutSettingData.to != '23:59') this.isInvalidTimeSetting = true; 
         if(fromTime != '00:00' && this.checkoutSettingData.to == '23:59') this.isInvalidTimeSetting = true;
         this.invalidTimeSettingErrorMessage = this.$t("account_page_facility_checkout_operation.error_message");
         if(moment(fromTime, "HH:mm").unix() > moment(toTime, "HH:mm").unix()) {
            this.invalidTimeSettingErrorMessage = this.$t("account_page_facility_checkout_operation.error_invalid_time_selection");
            this.isInvalidTimeSetting = true;
         }
      },

      async updateCheckoutTimingSettings() {
         const response = await this.$lionheart.put(
            "/v2/facility-settings/update-checkout-timing-settings",
            this.checkoutSettingData
         );

         if(response.status === 200) {
            this.showSuccess = true;
            await Promise.all([
               this.getSettings(),
               this.getCheckoutSettings()
            ]);
            setTimeout(() => {
               this.showSuccess = false
            }, 3000);
         }
      },

      isAnyFromTime(time) {
         return time == '00:00' ? this.$t("account_page_facility_checkout_operation.checkout_setting_anytime_label") : time;
      },
      isAnyToTime(time) {
         return time == '23:59' ? this.$t("account_page_facility_checkout_operation.checkout_setting_anytime_label") : time;
      },
      haveTimezone(time, timezone) {
         return time == '00:00' || time == '23:59' ? "" : timezone;
      }
   }

}
</script>
<template>
   <section>
      
      <div class="card-header py-3">
         <p>{{ $t('account_page_facility_checkout_operation.checkout_operation_note_text') }}</p>
      </div>

      <div class="card-body">
         <!-- success message -->
         <div class="alert alert-success alert-dismissible" role="alert" v-if="showSuccess">
            {{ $t("account_page_facility_checkout_operation.success_message") }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>
         <!-- invalid timing setting -->
         <div class="alert alert-danger alert-dismissible" role="alert" v-if="isInvalidTimeSetting">
            <!-- {{ $t("account_page_facility_checkout_operation.error_message") }} -->
              {{ invalidTimeSettingErrorMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
               <span aria-hidden="true">&times;</span>
            </button>
         </div>

         <form @submit.prevent="submitForm">
            <!-- Checkout time form -->
            <div>
               <h5>{{ $t('account_page_facility_checkout_operation.checkout_setting_title') }}</h5>
               <p>{{ $t('account_page_facility_checkout_operation.checkout_setting_description_text') }}</p>
            </div>

            <div class="container">
               <div class="row ">
                  <div class="col-lg-3">
                     <label class="col-form-label">
                        {{ $t('account_page_facility_checkout_operation.checkout_setting_label_name') }}
                     </label>
                  </div>
                  <div class="col-lg-9 col-md-12 col-sm-12">
                     <div class="form-group row">
                        <label for="" class="col-form-label"> {{ $t('account_page_facility_checkout_operation.checkout_setting_from') }}:</label>
                        <div class="col-sm-4">
                           <select class="form-control" v-model="checkoutSettingData.from">
                              <option
                                 v-for="(time, key) in checkoutFromTimingList"
                                 :value="time"
                                 :key="key"
                              > {{ isAnyFromTime(time) }} {{ haveTimezone(time, data.timeZone) }}
                              </option>
                           </select>
                        </div>

                        <label for="" class="col-form-label"> {{ $t('account_page_facility_checkout_operation.checkout_setting_to') }}:</label>
                        <div class="col-sm-4">
                           <select class="form-control" v-model="checkoutSettingData.to">
                              <option
                                 v-for="(time, key) in checkoutToTimingList"
                                 :value="time"
                                 :key="key"
                              > {{ isAnyToTime(time) }} {{ haveTimezone(time, data.timeZone) }}
                              </option>
                           </select>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <!-- END Checkout time form -->

            <hr>
            <!-- switch for auto checkout -->
            <div>
               <h5>{{ $t('account_page_facility_checkout_operation.batch_process_title') }}</h5>
               <p>{{ $t('account_page_facility_checkout_operation.batch_process_description_text') }}</p>
            </div>

            <div class="container">
               <div class="row">
                  <div class="col-lg-6 col-md-12 col-sm-12">
                     <div class="d-flex flex-row align-center mt-2">
                        <div>
                           {{ $t('account_page_facility_checkout_operation.batch_process_checkout_label') }}
                        </div>
                        <div class="pl-2 d-flex flex-row align-self-center">
                           <toggle-button
                              v-model="data.batchProcessSwitch"
                              :labels="{ checked: 'On', unchecked: 'Off' }"
                              :value="data.batchProcessSwitch"
                              :sync="true"
                           />
                        </div>
                     </div>
                  </div>

                  <!-- time list -->
                  <div class="col-lg-6 col-md-12 col-sm-12">
                     <div class="d-flex flex-row align-center">
                        <div class="d-flex flex-row align-self-center">
                           {{ $t('account_page_facility_checkout_operation.batch_process_checkout_batch_time_label') }}
                        </div>
                        <div class="pl-2">
                           <select class="form-control" v-model="data.time">
                              <option
                                 v-for="(time, key) in timeList"
                                 :value="time"
                                 :key="key"
                              > {{ time }} {{ data.timeZone }}
                              </option>
                           </select>
                        </div>
                     </div>
                  </div>
               </div>
               
               <div class="row mt-5">
                  <div class="col-lg-12" align="center">
                     <button 
                        :disabled="isInvalidTimeSetting"
                        type="submit" 
                        class="btn btn-primary ml-3"
                        @click="$bvModal.show('modal-confirmation')"
                     >
                        {{ $t('account_page_facility_checkout_operation.batch_process_confirm_button') }}
                     </button>
                  </div>
               </div>
            </div>
            <!-- END switch for auto checkout -->

         </form>

      </div>
   </section>
</template>